import React, { useEffect, useState } from 'react'
import { fileServices } from './fileServices';
import { Box, Grid, Typography, CircularProgress } from '@mui/material';
import { FolderItem, FileItem } from './FileItems';

const FolderContent = ({folder, setCurrentPath, setPathHistory, pathHistory}) => {
    const [folderContent, setFolderContent] = useState({folders: [], files: []});
    const [loading, setLoading] = useState(false);

    const fetchFolderContent = async () => {
        setLoading(true);
        try {
            const response = await fileServices.fetchFolderContent(folder);
            if(response.success == '1'){
                setFolderContent(response.data);
            }
        } finally {
            setLoading(false);
        }
    }
    useEffect(()=>{
        if(folder){
            fetchFolderContent();
        }
    },[folder])

    const handleSubFolderClick = (subFolder) => {
        const newPath = `${folder}/${subFolder}`;
        setPathHistory([...pathHistory, newPath]);
        setCurrentPath(newPath);
    }
  return (
    <Box sx={{width:'100%'}}>
        {loading ? (
            <Box sx={{display:'flex',justifyContent:'center',alignItems:'center',height:'200px'}}>
                <CircularProgress />
            </Box>
        ) : (
      <Grid container>
        {folderContent.files && folderContent.folders && (folderContent.files.length === 0 && folderContent.folders.length === 0) ?
          <Grid item xs={12}>
            <Typography variant='h6' align='center'>No content found in this folder</Typography>
          </Grid>
        :
        <>
          {folderContent.folders && folderContent.folders.length > 0 && folderContent.folders.map((subFolder,index)=>(
            <Grid item xs={3} sm={2} md={1} key={`folder-${index}`}>
              <FolderItem folder={subFolder} onDoubleClick={() => handleSubFolderClick(subFolder)} />
            </Grid>
            ))}
            {folderContent.files && folderContent.files.length > 0 && folderContent.files.map((file,index)=>(
                <Grid item xs={3} sm={2} md={1} key={`file-${index}`}>
                  <FileItem file={file} allFiles={folderContent.files} />
                </Grid>
            ))}
        </>
        }
      </Grid>
        )}
    </Box>
  )
}

export default FolderContent
